import Vue from 'vue'
import Router from 'vue-router'
import Etusivu from '@/components/Etusivu.vue'
import Game from '@/components/Game.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Etusivu,
      props: {
        num: '1',
        game: 'Wheel',
        minscore: 3
      }
    },
    {
      path: '/onnenpyora',
      name: 'Onnenpyörä',
      component: Game,
      props: {
        game: 'wheel'
      }
    },
    {
      path: '/hedelmapeli',
      name: 'Hedelmäpeli',
      component: Game,
      props: {
        game: 'slots'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js